import { isCcpaEligible } from 'client/utils/header-bidding/is-ccpa-eligible';
import { isHeaderBiddingPageWhitelisted } from './is-page-whitelisted';

export function getPbjsEnabled(state) {
  const prebidReactAds = Boolean(state?.featureFlags?.prebidReactAds);
  if (!prebidReactAds) {
    return false;
  }

  const privacy = state?.visitor?.privacy;
  if (privacy?.doNotSell) {
    return false;
  }

  const pageName = state?.pageContext?.legacy?.pageName || state?.pageContext?.page?.name;
  return isHeaderBiddingPageWhitelisted(pageName) && isCcpaEligible(privacy?.uspString);
}
